import React, { FC, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import { NavigationContext } from '@buyside/components/presentation/MainSiteLayout/mainSiteLayout';

import { formatCategoryLabel, RANKING_SECTIONS } from '@buyside/util/rankCategoryHelper';

import styles from './leftSidebarStyles.scss';

const LeftSidebar: FC = () => {
  const { sideNavigationOpen } = useContext(NavigationContext) || {};

  return (
    <div
      className={classNames(styles.leftSidebar, {
        [styles.sideNavigationOpen]: sideNavigationOpen
      })}
    >
      {RANKING_SECTIONS.map(section => (
        <div className={styles.leftSidebarSection} key={`sidebar-${section.title}`}>
          <h6 className={styles.leftSidebarSectionTitle}>{section.title}</h6>
          {section.categories.map(category => {
            return (
              <NavLink
                className={({ isActive }) =>
                  classNames(styles.leftSidebarSectionCategoryLink, {
                    [styles.active]: isActive
                  })
                }
                onClick={() => document.getElementById('mainContent')?.scrollTo({ top: 0 })}
                to={`/${category}`}
                key={`sidebar-${section.title}-${category}`}
              >
                {formatCategoryLabel(category)}
              </NavLink>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default LeftSidebar;
